import {
  DTOFilesGetQuery,
  DTOFilesResponse,
  DTOFileUploadFinalizePayload,
  DTOFileUploadFinalizeResponse,
  DTOFileUploadPayload,
  DTOFileUploadResponse,
} from "../../../dto";
import { RequestExecutor } from "../../../transport";

export class FilesEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  upload(designSystemId: string, versionId: string, body: DTOFileUploadPayload) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/files/upload`,
      DTOFileUploadResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  finalize(designSystemId: string, versionId: string, body: DTOFileUploadFinalizePayload) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/files/finalize`,
      DTOFileUploadFinalizeResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  get(designSystemId: string, versionId: string, query?: DTOFilesGetQuery) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/files`,
      DTOFilesResponse,
      { query: query ? new URLSearchParams(query) : undefined }
    );
  }
}
